module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/mask/1-2b8c335fcc0bbec846a514da3bd5fd70.jpg";